import React, { FC, useCallback, useEffect, useState } from 'react'
import { Popup, PopupProps } from '@yanolja-org/ya-com-popup'
import usePreventBack from '~/app/components/common/usePreventBack'
import { useRouter } from 'next/router'
import { backKeyBridgeFunction } from '~/app/utils/yaNativeUtils'

/**
 * PreventBackDialog component
 * author: soojin.oh
 */

type PreventBackDialogProps = {
  title: string
  description?: string
  buttons: PopupProps['buttons']
  onConfirmClick?: () => void
  onBackgroundClick?: (pageId: string) => void
}
// PreventBackDialog component
const PreventBackDialog: FC<PreventBackDialogProps> = function ({
  title,
  description,
  buttons,
  onConfirmClick,
  onBackgroundClick,
}) {
  const [isOpened, setOpened] = useState(false)
  const { asPath, back, push } = useRouter()
  const pathname = asPath.split('?')[0].split('#')[0]
  const { pageId } = usePreventBack(pathname, () => {
    setOpened(true)
  })

  const closeModalAndPushHash = useCallback(() => {
    push({ hash: pageId })
      .then(() => setOpened(false))
      .catch(e => {
        if (!e.cancelled) {
          throw e
        }
      })
  }, [pageId])

  useEffect(() => {
    const androidBackKeyFunc = () => {
      if (isOpened) {
        closeModalAndPushHash()
      } else {
        back()
      }
    }
    return backKeyBridgeFunction(androidBackKeyFunc, 'androidBackKeyFunc')
  }, [isOpened, closeModalAndPushHash])

  const handleBackgroundClick = () => {
    if (onBackgroundClick) {
      onBackgroundClick(pageId)
    } else {
      closeModalAndPushHash()
    }
  }

  const handleButtonClick = id => {
    if (id === 'confirm') {
      onConfirmClick ? onConfirmClick() : back()
    }
    if (id === 'cancel') {
      closeModalAndPushHash()
    }
  }

  return (
    <Popup
      popupId={'PREVENT_BACK_DIALOG'}
      title={title}
      description={description}
      buttons={buttons}
      isOpened={isOpened}
      onButtonClick={handleButtonClick}
      onBackgroundClick={handleBackgroundClick}
    />
  )
}

export default PreventBackDialog
